
import {Component, Vue} from "vue-property-decorator";
import {IBook} from "@/interfaces/book.interface";
import {httpResource} from "@/resources/http.resource";
import {IAppState} from "@/interfaces/app-state.interface";
import {ICorpsStore} from "@/modules/Corps/interfaces/corps-store.interface";
import AppSwitch from "@/components/AppSwitch.vue";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";

@Component({
  components: {AppSwitch}
})
export default class CorpsFilter extends Vue {
  isLoading: boolean = true;

  get storeState(): IAppState { return this.$store.state; }
  get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
  get formModel(): ICorpsStore.IFilters { return this.storeState.corps.filters; }
  get ownerCorpBook(): IBook.CatalogData[] { return this.storeState.book.books[IBook.BookName.corpsParents]; }

  get fltStr() { return this.formModel.fltStr; }
  set fltStr(value) { this.$store.commit('corps/setSubProperty', { block: 'filters', name: 'fltStr', value: value }); }

  get filterEmpty() {
    return !this.formModel.fltStr
      && this.formModel.fltEnabled
      && this.formModel.fltOwnerCorpId === this.userAccess.fltOwnerCorpId;
  }

  mounted() {
    setTimeout(() => {
      this.formItemChange(this.userAccess.fltOwnerCorpId, 'fltOwnerCorpId');
    });
  }

  async querySearchCorps(queryString, cb) {
    if (!Boolean(queryString) || (queryString && queryString.length < 3)) return cb([]);

    let asyncAction = async () => {
      const params = { tableName: IBook.TableName.Corps, searchText: queryString } ;
      const {data: {result: {corps: results } }} = await httpResource.httpAction({ action: IBook.ACTION, params });

      cb(results.map(item => { return { value: item.name }; }));
    };
    await this.$store.dispatch('defaultResourceAction', { asyncAction });
  }

  formItemChange(value, name) {
    this.$store.commit('corps/setSubProperty', { block: 'filters', name, value });
  }

  async onFilterClick () {
    await this.$store.dispatch('corps/getTable');
  }

  async clearFilters() {
    await this.$store.dispatch('corps/clearFilters');
  }

  async openCorpPopup() {
    await this.$store.dispatch('dialog/openDialog', {
      blockName: 'allPages',
      dialogName: 'corpPopup',
      payload: {
        corpId: null,
        createMode: true,
      },
    });
  }
}
